/**
 * Types + accessors for the CH-backed sub-account widget endpoint
 * (`POST /reporting/rollup/agencies/:agencyId/sub-accounts/:locationId/widget`).
 *
 * Every module row carries the bucket date plus the numeric metric fields the
 * chart requested; the comparison block is totals-only (no rows).
 */

export interface WidgetRowBase {
  date: string
  dateLabel: string
}

export interface WidgetModule<Row extends WidgetRowBase = WidgetRowBase> {
  key: string
  label?: string
  total?: number
  rows?: Row[]
  /** Present only on comparison modules — prior-period totals per field. */
  fields?: Record<string, number>
}

export interface WidgetResponse<Row extends WidgetRowBase = WidgetRowBase> {
  modules?: WidgetModule<Row>[]
  comparison?: { modules?: WidgetModule<Row>[] }
  traceId?: string
}

export function findModule<Row extends WidgetRowBase>(resp: WidgetResponse<Row> | undefined, key: string): WidgetModule<Row> | undefined {
  return resp?.modules?.find(m => m.key === key)
}

export function moduleRows<Row extends WidgetRowBase>(module: WidgetModule<Row> | undefined): Row[] {
  return module?.rows ?? []
}

export function comparisonFields(resp: WidgetResponse<WidgetRowBase> | undefined, key: string): Record<string, number> | undefined {
  return resp?.comparison?.modules?.find(m => m.key === key)?.fields
}
